export default "__VITE_ASSET__BWj$iHb4__"